import { FC } from "react";
import { Modal, ModalProps } from "antd";
import { CloseSvg } from "../../../assets/customIcons";
import styles from "./BasicModal.module.scss";

const BasicModal: FC<ModalProps> = ({ children, ...otherProps }) => {
  const defaultProps = {
    centered: true,
    closeIcon: <CloseSvg />,
    destroyOnClose: true,
    footer: null,
    mask: true,
    width: "fit-content",
    wrapClassName: styles["basicModal"],
  };

  return (
    <Modal {...defaultProps} {...otherProps}>
      {children}
    </Modal>
  );
};

export default BasicModal;
